import { useRef } from "react";

import { ManageSubscriptionRefs } from "../../types";
import { useGridRef } from "../useGridRef";

export const useManageSubscriptionRefs = (): ManageSubscriptionRefs => {
  const buttonOptionsRef = useRef<HTMLDivElement[]>([]);
  const [buttonGridRef, setButtonGridRefCurrent] = useGridRef<HTMLInputElement>();
  const [boxRef, setBoxRefCurrent] = useGridRef<HTMLDivElement>();

  return {
    box: {
      ref: boxRef,
      set: setBoxRefCurrent,
    },
    button: {
      ref: buttonGridRef,
      set: setButtonGridRefCurrent,
    },
    options: buttonOptionsRef,
  };
};
